import React from 'react';
import SectionLayout from './SectionLayout/SectionLayout';
import ContactForm from './Contact/ContactForm';
import { contactSection } from '../utils/data';

const Contact = ({ lang = 'es' }) => {
  const { title, description } = contactSection[lang]; // Obtiene el título y la descripción según el idioma

  return (
    <SectionLayout
      id="contact"
      title={title}
      description={description}
      titleClass="heading-sec__main--lt"
      descriptionClass="heading-sec__sub--lt"
    >
      <div className="contact__form-container">
        <ContactForm />
      </div>
    </SectionLayout>
  );
};

export default Contact;